module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0100.jpg?v=4a3c1509";